export enum EmployeeActionUi {
  RESEND_INVITE = 'RESEND_INVITE',
  RESTORE = 'RESTORE',
  DELETE = 'DELETE',
  EDIT = 'EDIT',
}
